import { Program, Plane, Mesh, TextureLoader, Transform } from 'ogl'

import vertex from '@shaders/waves.vert'
import fragment from '@shaders/waves.frag'

export default class GLWaves {
  constructor ({ gl, parent, sceneVars, meshes, paused = false }) {
    this.gl = gl
    this.parent = parent
    this.sceneVars = sceneVars
    this.meshes = meshes
    this.paused = paused

    this.isActive = false
    this.lt = Math.random()
    this.ltSpeed = 0.03

    this.createMesh()
  }

  createMesh () {
    const noiseWaves = TextureLoader.load(this.gl, {
      src: './static/textures/noise-normals-opti.png',
      wrapS: this.gl.REPEAT,
      wrapT: this.gl.REPEAT,
    })

    this.program = new Program(this.gl, {
      vertex,
      fragment,
      uniforms: {
        uAspectRatio: { value: 1 },
        uTime: { value: this.lt },
        uFrequency: { value: this.paused ? 60 : 40 },
        uAmplitude: { value: this.paused ? 0.4 : 0.2 },
        tNoise: { value: noiseWaves },
      },
      // cullFace: false,
    })

    const plane = new Plane(this.gl, {
      width: 15,
      height: 6,
      widthSegments: 128,
      heightSegments: 64,
    })

    this.mesh = new Mesh(this.gl, { geometry: plane, program: this.program })

    this.wrapper = new Transform(this.gl)

    this.wrapper.position.set(0, -1.25, -0.5)
    this.wrapper.rotation.set(-Math.PI * 0.5, 0, 0)

    this.mesh.setParent(this.wrapper)
    this.wrapper.setParent(this.parent)

    this.isActive = true
  }

  // EVENT HANDLERS
  handleResize () {}

  update (t) {
    if (this.isActive && !this.paused) {
      this.lt += this.ltSpeed

      this.program.uniforms.uTime.value = this.lt
    }
  }
}
